// Port of api/fuel/app/classes/filter/search/games/filters/query/game/count/official.php
export default {
	name: 'game.count.official',
	priority: 45,
	require: function(config, filter) {
		var c = filter.count && filter.count.official
		if (!c) return false
		return (c.from !== 1 && c.from !== 10) || c.to !== 10
	},
	run: function(config, filter, data, query) {
		var from = filter.count.official.from
		var to = filter.count.official.to
		var whitelist = filter.count.whitelist || []

		var where = []

		if (filter.count.exact) {
			where.push(['g.game_players_min', '=', from])
			where.push(['g.game_players_max', '=', to])
		} else {
			if (from !== 1) where.push(['g.game_players_min', '<=', from])
			if (from !== 1) where.push(['g.game_players_max', '>=', from])
			if (to !== 10) where.push(['g.game_players_min', '<=', to])
			if (to !== 10) where.push(['g.game_players_max', '>=', to])
		}

		if (whitelist.length) {
			query.whereGroup('OR', [
				['AND', [['g.game_id', 'in', whitelist]]],
				['AND', where]
			])
		} else {
			for (var i = 0; i < where.length; i++) {
				query.where(where[i][0], where[i][1], where[i][2])
			}
		}

		if (filter.threshold && filter.threshold.count) {
			query.where('g.game_players_count', '>=', filter.threshold.count)
		}
	}
}
